/**
 * Submit button should be isolated from other form elements based on UI design
 * It's might needed to be aligned left/center/right, but still in it's own row
 *
 * @example
 * <SubmitRow lobState={carLobState} />
 */
import * as React from "react";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import {
  StorefrontWizardRegionTypesContext,
  StorefrontWizardRegionTypes,
} from "components/flexComponents/PageLevelProviders/WizardContextProvider/StorefrontWizardRegionTypesContext";
import { OffsetGridItem } from "components/shared/OffsetGridItem/OffsetGridItem";
import { LOBState, HotelWizardState } from "src/stores/wizard/state";
import { SubmitButton } from "src/components/shared/SubmitButton/SubmitButton";
import { getShoppingGlobalMicroMessage } from "components/shared/StorefrontWizard/SubmitRow/UISShoppingGlobal";
import { observer } from "mobx-react";
import { GlobalConfig } from "stores/wizard/config";

export interface SubmitRowProps {
  lobState: LOBState;
  rfrr?: string;
  globalConfig?: GlobalConfig;
}

export const SubmitRow: React.FunctionComponent<SubmitRowProps> = observer(({ lobState, rfrr, globalConfig }) => {
  const isHalfWizard = lobState instanceof HotelWizardState ? lobState.config.halfWizard : false;
  const submitGridcolumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 8, large: 12 };
  const offsetColumn: UitkLayoutConditionalGridSpan = { medium: 3, large: 5 };
  const submitColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: isHalfWizard ? 12 : 2 };

  const wizardRegionContext = React.useContext(StorefrontWizardRegionTypesContext);
  const { STOREFRONT_WIZARD_REGION_BEX, STOREFRONT_WIZARD_REGION_COMET } = StorefrontWizardRegionTypes;
  const isStorefrontBEX = STOREFRONT_WIZARD_REGION_BEX === wizardRegionContext;
  const isStorefrontCOMET = STOREFRONT_WIZARD_REGION_COMET === wizardRegionContext;
  const isStorefront = isStorefrontBEX || isStorefrontCOMET;

  const uisShoppingGlobal = getShoppingGlobalMicroMessage(lobState);

  return (
    <UitkSpacing padding={{ blockstart: "three" }}>
      <UitkLayoutGrid columns={submitGridcolumns} space="three">
        {isStorefront && <OffsetGridItem colSpan={offsetColumn} />}

        <SubmitButton
          lobState={lobState}
          colSpan={submitColSpan}
          rfrr={rfrr}
          uisPrimeMicroMessages={uisShoppingGlobal}
          globalConfig={globalConfig}
        />
      </UitkLayoutGrid>
    </UitkSpacing>
  );
});
